export const toDateKey = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const buildCalendarDays = (month: Date, weekStartsOn: 0 | 1 = 0) => {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const leadingDays = (first.getDay() - weekStartsOn + 7) % 7;
  const start = new Date(month.getFullYear(), month.getMonth(), 1 - leadingDays);
  return Array.from({ length: 42 }, (_, index) =>
    new Date(start.getFullYear(), start.getMonth(), start.getDate() + index)
  );
};

export const formatTime = (value: string | null | undefined, timeFormat: 12 | 24) => {
  if (!value) return '';
  if (timeFormat === 24) return value;
  const [hours, minutes] = value.split(':').map(Number);
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${String(minutes).padStart(2, '0')} ${suffix}`;
};
